import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Settings page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";

import {
  initialValue,
  valueEdit,
} from "./components/DadosEvento/schemas/initialValues";
import SidenavEvento from "./components/SidenavEvento";

import DadosEvento from "./components/DadosEvento";
import LotesEvento from "./components/LotesEvento";
import CategoriaDistancia from "./components/CategoriaDistancia";
import TiposPagamentosEventos from "./components/TiposPagamentos";
import CupomEvento from "./components/CupomEvento";
import AdiantamentoEvento from "./components/AdiantamentoEvento";
import Kits from "./components/kits";
import DeleteEvento from "./components/DeleteEvento";
import PublicadoSite from "./components/PublicadoSite";
import ListaInscritos from "./components/ListaInscritos";
import PatrocinadoresEvento from "./components/PatrocinadoresEvento";
import DespesasEvento from "./components/DespesasEvento";
import EventoFoto from "./components/EventoFoto";

import { IEventoResponse } from "interfaces/eventos";
import { getEventosBySlug } from "services/evento";
import ShareLinkInscrito from "./components/ShareLinkInscrito";

export type PagesEvento =
  | "dados"
  | "lotes"
  | "disCat"
  | "typePay"
  | "cupom"
  | "adiantamento"
  | "kits"
  | "patrocinadores"
  | "despesas"
  | "delele-evento"
  | "publicado-site"
  | "list-inscritos"
  | "compartilhar-link"
  | "fotos";

export default function Eventos(): JSX.Element {
  const { eventoSlug } = useParams();
  const [evento, setEvento] = useState<IEventoResponse | null>(null);
  const [hasUpdateEvento, setHasUpdateEvento] = useState<number>(0);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [page, setPage] = useState<PagesEvento>("dados");
  const [valueForm, setValueForm] = useState<any>(null);

  const handleUpdateEvento = () => setHasUpdateEvento(new Date().getTime());

  useEffect(() => {
    (async () => {
      const slug = eventoSlug?.trim();
      const isNovo = !slug || slug === "criar";
      if (!isNovo) {
        getEventosBySlug(slug).then(async (resp) => {
          setIsEdit(true);
          setEvento(resp);
          setValueForm((resp && (await valueEdit(resp))) || null);
        });
      } else {
        setEvento(null);
        setValueForm(initialValue);
        setIsEdit(false);
      }
    })();
  }, [eventoSlug, hasUpdateEvento]);

  // Exibir a pagina definida pelo usuário
  const getPage = (page: PagesEvento) => {
    if (!valueForm) return;

    switch (page) {
      case "dados":
        return (
          <DadosEvento
            evento={evento}
            updateEvento={handleUpdateEvento}
            valueForm={valueForm}
            gotoPage={handleChangePage}
            isEdit={isEdit}
          />
        );
      case "lotes":
        return (
          <LotesEvento evento={evento} updateEvento={handleUpdateEvento} />
        );

      case "disCat":
        return (
          <CategoriaDistancia
            evento={evento}
            updateEvento={handleUpdateEvento}
          />
        );

      case "typePay":
        return (
          <TiposPagamentosEventos
            evento={evento}
            updateEvento={handleUpdateEvento}
          />
        );

      case "cupom":
        return <CupomEvento evento={evento} />;

      case "adiantamento":
        return (
          <AdiantamentoEvento
            evento={evento}
            updateEvento={handleUpdateEvento}
          />
        );

      case "kits":
        return <Kits evento={evento} updateEvento={handleUpdateEvento} />;

      case "patrocinadores":
        return (
          <PatrocinadoresEvento
            evento={evento}
            updateEvento={handleUpdateEvento}
          />
        );

      case "despesas":
        return <DespesasEvento evento={evento} />;

      case "delele-evento":
        return <DeleteEvento evento={evento} />;

      case "publicado-site":
        return (
          <PublicadoSite evento={evento} updateEvento={handleUpdateEvento} />
        );

      case "list-inscritos":
        return <ListaInscritos evento={evento} />;

      case "compartilhar-link":
        return <ShareLinkInscrito evento={evento} />;

      case "fotos":
        return <EventoFoto evento={evento} />;

      default:
        return (
          <DadosEvento
            evento={evento}
            updateEvento={handleUpdateEvento}
            valueForm={valueForm}
            gotoPage={handleChangePage}
          />
        );
    }
  };

  const handleChangePage = (page: PagesEvento) => setPage(page);

  return (
    <BaseLayout>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          {evento && (
            <Grid item xs={12} lg={3}>
              <SidenavEvento
                onSelect={handleChangePage}
                evento={evento}
                onPublished={handleUpdateEvento}
              />
            </Grid>
          )}

          <Grid item xs={12} lg={evento ? 9 : 12}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {getPage(page)}
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </BaseLayout>
  );
}
